import axios from 'axios'
import authHeader from './auth-header'

class AtividadesV2Service {
  handoff (options = {}) {
    return axios.post(
      process.env.VUE_APP_API_URL + 'atividades-v2/sso/ticket',
      {
        redirect_to: options.redirectTo || '/',
        embedded: true
      },
      { headers: authHeader() }
    )
  }

  async redirectUrl (options = {}) {
    const response = await this.handoff(options)
    return response.data.redirect_url
  }
}

export default new AtividadesV2Service()
